import { Map } from "immutable";
import { STATE_STATUS, RETAILER_RISK_CONTROL_ACTIONS } from "constants";

const INITIAL_STATE = new Map({
    retailer_risk_control_data: null,
    retailer_risk_control_status: STATE_STATUS.UNFETCHED,
});

export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
    case RETAILER_RISK_CONTROL_ACTIONS.FETCH_RETAILER_RISK_CONTROL_DETAIL:
        return state.set("retailer_risk_control_status", STATE_STATUS.FETCHING);
    case RETAILER_RISK_CONTROL_ACTIONS.FETCHED_RETAILER_RISK_CONTROL_DETAIL:
        return state
            .set("retailer_risk_control_status", STATE_STATUS.FETCHED)
            .set("retailer_risk_control_data", payload.dbRiskControlDetail
        );
    case RETAILER_RISK_CONTROL_ACTIONS.FAILED_FETCH_RETAILER_RISK_CONTROL_DETAIL: {
        return state.set("retailer_risk_control_status", STATE_STATUS.FETCH_FAILED);
    }
    case RETAILER_RISK_CONTROL_ACTIONS.UPDATE_RETAILER_RISK_CONTROL_DETAIL:
        return state
        .set("retailer_risk_control_status", STATE_STATUS.UPDATING);
    case RETAILER_RISK_CONTROL_ACTIONS.UPDATED_RETAILER_RISK_CONTROL_DETAIL:
        return state
            .set("retailer_risk_control_status", STATE_STATUS.UPDATED)
            .set("retailer_risk_control_data", payload.retailerRiskControlDetail);
    case RETAILER_RISK_CONTROL_ACTIONS.FAILED_UPDATE_RETAILER_RISK_CONTROL_DETAIL:
        return state.set("retailer_risk_control_status", STATE_STATUS.UPDATE_FAILED);
    default:
        return state;
    }
};
